import React from 'react';

import { Component } from '@poa/core';
import { action, Observer, observable } from '@poa/state';


import SynctoolIcon from '../components/icons/synctool';
import CopyIcon from '../components/icons/copy';
import ChartIcon from '../components/icons/chart';
import ChevronDownIcon from '../components/icons/chevron-down';

import { ShareLinkChartModal } from '../components/links-modal/links_chart';
import LinksUserModal from '../components/links-modal/links-user-modal';



class ShareLinkPage extends React.Component {
  store; // injected by Poa
  actions; // injected by Poa
  t; // injected by Poa


  localState = observable({
    accLinkIcon: true,
    trialLinkIcon: true,
    isModalOpened: false,
    isLinkUserModalOpened: false,
    linkId: null,
  });


  handleAccLinkCopy = (url) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url);
    } else {
      let textarea = document.createElement('textarea');
      textarea.textContent = url;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
    }

    this.localState.accLinkIcon = false;

    setTimeout(() => {
      this.localState.accLinkIcon = true;
    }, 3000);
  }

  handleTrialLinkCopy = (url) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url);
    } else {
      let textarea = document.createElement('textarea');
      textarea.textContent = url;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
    }

    this.localState.trialLinkIcon = false;

    setTimeout(() => {
      this.localState.trialLinkIcon = true;
    }, 3000);

  }

  onModalClose = action(() => {
    this.localState.isModalOpened = false;
  });

  onModalOpen = action(() => {
    this.localState.isModalOpened = true;
  });

  onUsersModalClose = action(() => {
    this.localState.linkId = null;
    this.localState.isLinkUserModalOpened = false;
  });

  onUsersModalOpen = action((linkId) => {
    this.localState.linkId = linkId;
    this.localState.isLinkUserModalOpened = true;
  });

  render() {
    const { data } = this.store.shareLinks;

    return (
      <div className="content">
        <div className="shared-links-container">
          <div className="shared-links-container__inner">
            <div className="logo logo-login">
              <SynctoolIcon />
            </div>
            <div className="shared-links-container__chart-box">

              <button className="share-chart-icon" onClick={this.onModalOpen}>
                <ChartIcon />
                <h2>View Graph</h2>
              </button>
            </div>
            {
              <Observer>
                {() => (
                  data === null ? (
                    <div className="shared-links-container__box">
                      <div className="not-found">
                        Link Not Found
                      </div>
                    </div>
                  )
                    :
                    <div className={`shared-links-container__box`}>
                      <div className='link-raw '>
                        <h2>Account:</h2>
                        <div className='copy_icon'>
                          <a className='account-link' href={data.account_url}>
                            {data.account_name}
                          </a>
                          <div className='icon_inner' onClick={() => this.handleAccLinkCopy(data.account_url)}>
                            {
                              this.localState.accLinkIcon ?
                                <CopyIcon />
                                :
                                <ChevronDownIcon style={{ fill: 'green' }} />
                            }
                          </div>
                        </div>
                      </div>
                      <div className='link-raw '>
                        <h2>{data.link_type === 'trial' ? "Trial link:" : "Tracking link"}</h2>
                        <div className='copy_icon'>
                          <a href={data.link_url}>
                            {data.link_name}
                          </a>
                          <div className='icon_inner' onClick={() => this.handleTrialLinkCopy(data.link_url)}>
                            {
                              this.localState.trialLinkIcon ?
                                <CopyIcon />
                                :
                                <ChevronDownIcon style={{ fill: 'green' }} />
                            }
                          </div>
                        </div>
                      </div>
                      <div className='link-raw '>
                        <h2>Link created:</h2>
                        <div style={{ textAlign: 'right' }}>
                          <h4>{new Date(data.created_at + " UTC").toLocaleString('en-GB', { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</h4>
                          {data.is_finished ? <h4 style={{ color: 'red' }}>(finished)</h4> : <h4 style={{ color: 'green' }}>(active)</h4>}
                        </div>
                      </div>
                      <div className='link-raw '>
                        <h2>Link expires:</h2>
                        {
                          data.expired_at === null ?
                            <div className='claim-count'>∞</div>
                            :
                            <h4>{new Date(data.expired_at + " UTC").toLocaleString('en-GB', { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</h4>
                        }

                      </div>

                      {
                        data.link_type === 'trial' ?
                          <>
                            <div className='link-raw '>
                              <h2>Access Duration:</h2>
                              <div className='claim-count'>{!data.subscription_days ? "∞" : `${data.subscription_days} days`}</div>
                            </div>
                            <div className='link-raw '>
                              <h2>Offer Limit:</h2>
                              <div className='claim-count'>{!data.subscription_qty ? "∞" : data.subscription_qty}</div>
                            </div>
                            <div className='link-raw '>
                              <h2>Claim count:</h2>
                              <div className='claim-count' onClick={() => this.onUsersModalOpen(data.id)}>{data.claimes_qty}</div>
                            </div>
                            <div className='link-raw '>
                              <h2>Total Revenue (Net):</h2>
                              <p className='total-revenue'>$ {data.revenue}</p>
                            </div>
                            <div className='link-raw '>
                              <h2>Data Last Updated:</h2>
                              <h4>{new Date(data.updated_at + " UTC").toLocaleString('en-GB', { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</h4>
                            </div>
                          </>
                          :
                          <>
                          <div className='link-raw '>
                            <h2>Transitions count:</h2>
                            <div className='claim-count'>{data.transitions_count}</div>
                          </div>
                            <div className='link-raw '>
                              <h2>Subscription count:</h2>
                              <div className='claim-count' onClick={() => this.onUsersModalOpen(data.id)}>{data.claimes_qty}</div>
                            </div>

                            <div className='link-raw '>
                              <h2>Total Revenue (Net):</h2>
                              <p className='total-revenue'>$ {data.revenue}</p>
                            </div>
                            <div className='link-raw '>
                              <h2>Data Last Updated:</h2>
                              <h4>{new Date(data.updated_at + " UTC").toLocaleString('en-GB', { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</h4>
                            </div>
                          </>

                      }


                    </div>
                )}
              </Observer>
            }

            <Observer>
              {() => (
                <ShareLinkChartModal
                  isOpened={this.localState.isModalOpened}
                  requestClose={this.onModalClose}
                  linkId={data ? data.id : null}
                />
              )}
            </Observer>
            <Observer>
              {() => (
                <LinksUserModal
                  isOpen={this.localState.isLinkUserModalOpened}
                  onRequestClose={this.onUsersModalClose}
                  selectedTrialLinkId={this.localState.linkId}
                  linkType={data ? `${data.link_type}_link`: 'trial_link'}
                />
              )}
            </Observer>
          </div>
        </div>
      </div>
    );
  }
}

export default Component({ namespaces: ['share-link'] })(ShareLinkPage);
